import { render, staticRenderFns } from "./Personslistformsheet.vue?vue&type=template&id=52797ed0"
import script from "./Personslistformsheet.vue?vue&type=script&lang=js"
export * from "./Personslistformsheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports